var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
import React, { Fragment } from "react";
import classNames from "classnames";
import { Heading, Link, PicturePlaceholder, MediaQuery } from "@riseart/common";
import { tileCardCls, tileCardStyleMainCls, tileCardStyleMainLargeCls, tileCardStyleVerticalCls, tileCardStyleVerticalPreviewCls, tileCardControlsCls, tileCardIconControlsCls, tileCardControlsSeparatorCls, tileCardMediaCls, tileCardContentCls, tileCardContentRowCls, tileCardContentMainCls, tileCardContentMainPaddedCls, tileCardHeadingsCls, tileCardTitleCls, tileCardAuthorCls, tileCardDetailsCls, tileCardPriceCls, tileCardDiscountCls, tileCardOptionsCls, tileCardOptionsRowCls, tileCardAdditionalCls, screenExtraSmallMax, screenSmall } from "./Card.less";
var DISPLAY_SETTINGS = {
  main: {
    className: tileCardStyleMainCls,
    showActionButtons: true,
    showAdditionalInfo: true,
    disableLinks: false
  },
  mainLarge: {
    className: classNames(tileCardStyleMainCls, tileCardStyleMainLargeCls),
    showActionButtons: true,
    showAdditionalInfo: true,
    disableLinks: false
  },
  vertical: {
    className: tileCardStyleVerticalCls,
    showActionButtons: true,
    showAdditionalInfo: false,
    disableLinks: false
  },
  verticalPreview: {
    className: tileCardStyleVerticalPreviewCls,
    showActionButtons: false,
    showAdditionalInfo: true,
    disableLinks: true
  },
  preview: {
    className: tileCardStyleMainCls,
    showActionButtons: false,
    showAdditionalInfo: true,
    disableLinks: false
  }
};
function CardTile(_ref) {
  var _ref$displayStyle = _ref.displayStyle, displayStyle = _ref$displayStyle === void 0 ? "main" : _ref$displayStyle, title = _ref.title, url = _ref.url, author = _ref.author, details = _ref.details, price = _ref.price, discount = _ref.discount, additional = _ref.additional, options = _ref.options, pictureProps = _ref.pictureProps, actionButtons = _ref.actionButtons, actionIcons = _ref.actionIcons;
  var _ref2 = displayStyle && DISPLAY_SETTINGS[displayStyle] || DISPLAY_SETTINGS.main, cartStyleClassName = _ref2.className, showActionButtons = _ref2.showActionButtons, showAdditionalInfo = _ref2.showAdditionalInfo, disableLinks = _ref2.disableLinks;
  var showButtons = showActionButtons && actionButtons && actionButtons.length;
  var showIcons = showActionButtons && actionIcons && actionIcons.length;
  return /* @__PURE__ */ React.createElement("div", {
    className: classNames(tileCardCls, cartStyleClassName)
  }, /* @__PURE__ */ React.createElement("div", {
    className: tileCardMediaCls
  }, disableLinks || !url ? /* @__PURE__ */ React.createElement(PicturePlaceholder, pictureProps) : /* @__PURE__ */ React.createElement(Link, {
    to: url,
    title
  }, /* @__PURE__ */ React.createElement(PicturePlaceholder, pictureProps))), /* @__PURE__ */ React.createElement("div", {
    className: tileCardContentCls
  }, showIcons ? /* @__PURE__ */ React.createElement("div", {
    className: tileCardIconControlsCls
  }, actionIcons.map(function(button, index) {
    return /* @__PURE__ */ React.createElement(Fragment, null, index ? /* @__PURE__ */ React.createElement("span", {
      className: tileCardControlsSeparatorCls
    }) : null, button);
  })) : null, /* @__PURE__ */ React.createElement(MediaQuery, {
    minWidth: screenSmall
  }, function(showSection) {
    return /* @__PURE__ */ React.createElement("div", showButtons && showSection ? {
      className: tileCardContentRowCls
    } : {}, showButtons && showSection ? /* @__PURE__ */ React.createElement("div", {
      className: tileCardControlsCls
    }, actionButtons.map(function(button) {
      return button;
    })) : null, /* @__PURE__ */ React.createElement("div", {
      className: classNames(tileCardContentMainCls, _defineProperty({}, tileCardContentMainPaddedCls, showIcons))
    }, /* @__PURE__ */ React.createElement("div", {
      className: tileCardHeadingsCls
    }, /* @__PURE__ */ React.createElement(Heading, {
      tag: "h3",
      level: "5",
      className: tileCardTitleCls
    }, disableLinks || !url ? title : /* @__PURE__ */ React.createElement(Link, {
      to: url,
      title
    }, title)), author ? /* @__PURE__ */ React.createElement(Heading, {
      tag: "h4",
      level: "6",
      className: tileCardAuthorCls
    }, author) : null), details ? /* @__PURE__ */ React.createElement("div", {
      className: tileCardDetailsCls
    }, details) : null, price ? /* @__PURE__ */ React.createElement("div", {
      className: tileCardPriceCls
    }, price, discount ? /* @__PURE__ */ React.createElement("span", {
      className: tileCardDiscountCls
    }, discount) : null) : null));
  }), options ? /* @__PURE__ */ React.createElement("div", {
    className: tileCardOptionsCls
  }, options.map(function(option) {
    return /* @__PURE__ */ React.createElement("div", {
      className: tileCardOptionsRowCls
    }, option);
  })) : null, showAdditionalInfo && additional ? /* @__PURE__ */ React.createElement("div", {
    className: tileCardAdditionalCls
  }, additional) : null, showButtons ? /* @__PURE__ */ React.createElement(MediaQuery, {
    maxWidth: screenExtraSmallMax
  }, /* @__PURE__ */ React.createElement("div", {
    className: tileCardControlsCls
  }, actionButtons.map(function(button) {
    return button;
  }))) : null));
}
__name(CardTile, "CardTile");
export {
  CardTile
};
